export const HOTMART = 'hotmart'
export const PAYMENT_NEW_STATUS = 'new'
export const SUBSCRIPTION_STATUS = 'payed'
export const SUBSCRIPTION_DEMO = 'demo'
export const SUBSCRIPTION_TEAM = 'Team'

export const SUMMER_PROMOCODE = 'HEAT40'
